import { create } from "zustand"

/**
 * What's New Store - UI state only
 * Note: lastSeenVersion is now stored in the database via useUISettings hook
 * This store only manages the modal's open/closed state
 */
type WhatsNewStore = {
  open: boolean
  setOpen: (open: boolean) => void
}

export const useWhatsNewStore = create<WhatsNewStore>()((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}))
